import React from 'react';
import PropTypes from 'prop-types';
import styles from './media.scss';

const Media = ({ children, centered, className, ...options }) => {
  const classNames = [styles.media];
  if (centered) {
    classNames.push(styles.mediaCenter);
  }
  if (className) {
    classNames.push(className);
  }

  return (
    <div className={classNames.join(' ')} {...options}>
      {children}
    </div>
  );
};

Media.propTypes = {
  children: PropTypes.node.isRequired,
  centered: PropTypes.bool,
  className: PropTypes.string
};

Media.defaultProps = {
  centered: false,
  className: null
};

export default Media;
